// extracted by mini-css-extract-plugin
export default {"field":"InformationEdit_field__sz2fT","text":"InformationEdit_text__asbzT"};